import './App.css';
import { NavBar } from './Components/NavBar/NavBar';
import { FlowView } from './Components/FlowView/FlowView';
import { ContextImageView } from './Components/ContextImageView/ContextImageView';
import { FlowDataProvider, useFlowData } from './Context/FlowDataProvider';
import { PathAndCircleEmbed } from './Components/PathAndCircleEmbed';
import React from 'react';

// Inner component that has access to FlowData context
const AppContent: React.FC = () => {
  const flowData = useFlowData();
  const isPathAndCircleEnabled = flowData?.isPathAndCircleEnabled ?? false;

  const checkoutContent = (
    <div className="App">
      <NavBar
        brandLogo={'https://storage.googleapis.com/media.leelalife.com/shared/logo_v2.svg'}
      />
      <ContextImageView />
      <FlowView />
    </div>
  );

  // If Path & Circle is not enabled, show normal checkout flow
  if (!isPathAndCircleEnabled) {
    return checkoutContent;
  }

  // If Path & Circle is enabled, show the authenticated client portal
  // Keep checkout content mounted but hidden so ReportViewer can receive events
  return (
    <>
      <div style={{ width: '100%', height: '100vh' }}>
        <PathAndCircleEmbed />
      </div>
      {/* Keep checkout mounted but hidden so ReportViewer can receive window events */}
      <div style={{ display: 'none' }}>
        {checkoutContent}
      </div>
    </>
  );
};

export const App: React.FC<{}> = () => {
  return (
    <FlowDataProvider>
      <AppContent />
    </FlowDataProvider>
  );
};

export default App;
